<template>
  <div v-loading.fullscreen="loading">
  <div class="full_layout" v-if="list!=null">
    <!-- CheckState 验收：-1待查验，0不通过，1通过并放款，2通过待买家确认 -->
    <el-alert 
    :title="$t('alert.checkeFinish')"
    type="warning"
    :closable="false"
    show-icon class="RemainingAlert"  v-if="list.OrderStatus==3&&list.BusinessType == 2&&list.CheckState==2">
  </el-alert>
  <!--  countDownType:{{countDownType}}，
    OrderType:{{list.OrderType}}，
    countDown:{{countDown}}，
    DoveCountDown(countDown):{{DoveCountDown(countDown)}}，
   doveTitle:{{doveTitle}} 
   {{doveDescription}} -->
   <el-alert 
    :title="doveTitle"
    :closable="false"
    type="error"
    show-icon class="RemainingAlert" v-if="list.OrderStatus==1&&countDownType<3&&countDown!=0&&countDownType!=0">
  </el-alert>

    <el-alert 
    :title="doveTitle"
    :description="doveDescription"
    :closable="false"
    type="error"
    show-icon class="RemainingAlert" v-if="list.OrderStatus==1&&countDownType>=3&&countDown!=0">
  </el-alert>
<!--   CountDownType：倒计时类型
CountDown：倒计时秒数
259200 //72小时

待支付状态可能出现的状态：
待支付状态 = 1,
鸽子待支付状态 = 2,
卖家可关闭状态 = 3,
系统自动关闭 = 4,
系统再次自动关闭 = 5,

待收货状态可能出现的状态：
系统自动收货 = 6 -->
    <div class="order_num text_gray">{{$t('colon.orderNumber')}} {{list.Code}}</div>
    <div class="deatil_pay_box">
      <div class="paidPay">
        <div v-if="list.IsBuyAppraisal&&list.OrderType==1" class="text_gray">{{OrderStatus[6]}}</div>
        <div v-else :class="CountDown(list.LastPayDate) == '00:00' && list.OrderStatus==1 ? 'text_red':list.OrderStatus!=6?'text_orange':'text_gray'">
          {{OrderStatus[list.OrderStatus]}}</div>
        <div class="text_gray CloseDate_time" v-if="list.OrderStatus==6">{{$t('colon.CloseTime')}} {{list.CloseDate|setTimeSS}}</div>
          <!-- <div v-else :class="list.OrderStatus==1 ? 'text_red':'text_orange'">
          {{OrderStatus[list.OrderStatus]}}</div> -->
        <div class="Remaining_time" v-if="list.OrderStatus==1" :class="list.OrderStatus==1 ? 'text_red':'text_orange'">{{countDownType>1?$t('symbol.systemClose'):$t('base.remaining')}} : {{countDown!=0&&countDownType!=0?DoveCountDown(countDown):'00:00'}}</div>
        <!-- <div class="Remaining_time" :class="CountDown(list.LastPayDate) == '00:00' ? 'text_red Remaining_red':'text_orange'"
          v-if="list.OrderStatus==1">Remaining: {{CountDown(list.LastPayDate)}}</div> -->
        <span v-if="list.OrderStatus==1&&!isSeller" @click="BuyItNow(list)">{{$t('base.payNow')}}</span>
      </div>
      <div class="steps_box">
        <div class="greed">
          <div class="dot first">
            <span class="yes shipped"></span>
            <span class="dot_s"></span>
            <span class="dot_s"></span>
            <span class="dot_s"></span>
          </div>
          <div class="steps_txt first">
            {{$t('base.submitOrders')}}<br>{{list.CreateDate|setTimeSS}}
          </div>
        </div>
        <!-- <div :class="list.OrderStatus>=2 && list.PayDate && list.OrderStatus<6?'greed':''"> -->
        <div :class="list.OrderStatus>=2 && list.OrderStatus<6?'greed':''">
          <div class="dot">
            <span class="dot_s"></span>
            <span class="dot_s"></span>
            <span class="yes transit"></span>
            <span class="dot_s"></span>
            <span class="dot_s"></span>
            <span class="dot_s"></span>
          </div>
          <div class="steps_txt" v-if="list.OrderStatus>=2">
            {{$t('base.payForOrder')}}<br>{{list.PayDate|setTimeSS}}
          </div>
          <div class="steps_txt" v-else>
            {{$t('base.payForOrder')}}
          </div>
        </div>
        <!-- <div :class="list.OrderStatus>=3 && list.SendTime && list.OrderStatus<6?'greed':''"> -->
        <div :class="list.OrderStatus>=3  && list.OrderStatus<6?'greed':''">
          <div class="dot">
            <span class="dot_s"></span>
            <span class="dot_s"></span>
            <span class="yes delivery"></span>
            <span class="dot_s"></span>
            <span class="dot_s"></span>
            <span class="dot_s"></span>
          </div>
          <div class="steps_txt" v-if="list.OrderStatus>=3">
            {{$t('base.sellerShipped')}}<br>{{list.SendTime|setTimeSS}}
          </div>
          <div class="steps_txt" v-else>
            {{$t('base.shipped')}}
          </div>
        </div>
        <!-- <div :class="list.OrderStatus>=5 && list.AcceptTime && list.OrderStatus<6?'greed':''"> -->
        <div :class="list.OrderStatus>=5  && list.OrderStatus<6?'greed':''">
          <div class="dot">
            <span class="dot_s"></span>
            <span class="dot_s"></span>
            <span class="yes delivered"></span>
          </div>
          <div class="steps_txt" v-if="list.OrderStatus>=5">
            {{$t('base.finish')}}<br>{{list.AcceptTime|setTimeSS}}
          </div>
          <div class="steps_txt" v-else>
            {{$t('base.finish')}}
          </div>
        </div>
      </div>
    </div>
    <div class="detail_box">
      <div class="detail_info">
        <div class="detail_info_box">
          <h3>{{$t('base.buyerInfo')}}</h3>
          <div v-if="!isSeller">
            <span>{{$t('base.nickName')}}</span>
            <div class="detail_msg">
              <!-- {{userInfo.NickName == !userInfo.NickName?'-':userInfo.NickName}} -->
              {{ list.BuyerName?list.BuyerName:userInfo.NickName}}
            </div>
          </div>
          <div>
            <span>{{$t('base.shippingName')}}</span>
            <div class="detail_msg">
              <!-- {{list.BusinessType == 2 ? 'Card Hobby':list.Consignee+' '+list.Mobile}} -->
              {{list.BusinessType == 2 ? list.Consignee:list.Consignee+' '+list.Mobile}}
            </div>
            <!-- <div class="detail_msg">
              {{list.Consignee}}
            </div> -->
          </div>
          <div v-if="list!=null">
            <span>{{$t('base.shippingAddress')}}</span>
            <div class="address_s" v-if="list.BusinessType!=2||(list.BusinessType==2&&list.IsCustomAdress)">
              <div v-if="list.Address"> {{list.Address}},</div>
              <div v-if="list.City">{{list.City}},</div>
              <div v-if="list.Provice">{{list.Provice}},</div>
              <div v-if="list.ZipCode">{{list.ZipCode}}</div>
            </div>
            <div class="address_s" v-else>
              <div>{{cardHobbyAddress}}</div>
            </div>
          </div>
        </div>
        <div class="detail_info_box">
          <h3>{{$t('base.sellerInformation')}}</h3>
          <div>
            <span>{{$t('base.sellersName')}}</span>
            <div class="detail_msg" v-if="list.OrderType!=0">
              {{$t('base.cardHobby')}}
            </div>
            <div class="detail_msg" v-else>
              {{list.SellerName == !list.SellerName?'-':list.SellerName}}
            </div>
          </div>
          <div>
            <span>{{$t('base.locatedIn')}}</span>
            <div class="detail_msg" v-if="list.OrderType!=0">
              California
            </div>
            <div class="detail_msg" v-else>
              {{list.SellerProvince == !list.SellerProvince?'-':list.SellerProvince}}
            </div>
          </div>
        </div>
        <div class="detail_info_box" v-if="list.OrderStatus!=1">
          <h3>{{$t('base.shippinginformation')}}</h3>
          <div>
            <span>{{$t('base.carrier')}}</span>
            <div class="detail_msg">
              {{list.ExpressName}}
            </div>
          </div>
          <div>
            <span>{{$t('base.trackingNumber')}}</span>
            <div class="detail_msg">
              {{list.Express}}
            </div>
          </div>
        </div>
        <div class="detail_info_box" v-else></div>
      </div>
      <div class="detail_steps" v-if="list.OrderStatus!=1">
        <div class="steps_list" v-for="(item,index) in expList.Traces" :key="index" v-if="expList.Traces&&expList.Traces.length>0">
          <div class="steps_list_up">
            <span class="time">{{item.AcceptTime|setTimeSS}}</span>
            <span class="dott"></span>
            <span class="add">{{item.AcceptStation}}</span>
          </div>
          <div class="steps_line"></div>
        </div>
        <div class="steps_list error" v-if="expList.Traces&&expList.Traces.length<=0">
          <div>{{$t('base.NoLogistics')}}</div>
        </div>
      </div>
      <div class="detail_steps" v-else></div>
    </div>
    <!-- 非跨境详情 -->
    <div class="table_detail_box" v-if="list.BusinessType!=2||(list.BusinessType==2&&list.IsCustomAdress)">
      <div class="table_head BusinessType_head">
        <div class="commod head_box">{{$t('base.item')}}</div>
        <div class="head_box">{{$t('base.quantity')}}</div>
        <!-- <div class="head_box">{{list.OrderType!=1?(list.Details[0].ByWay!=1?'Winning bid':'Price'):"Price"}}</div> 2022/11/15-->
        <div class="head_box">{{$t('base.itemPrice')}}</div>
        <div class="flex_layout_end flex_one">
          <div class="head_box">{{$t('base.shipping')}}</div>
          <div class="head_box Premium" v-if="list.OrderType!=1&&!isSeller">{{$t('base.buyerPremium')}}</div>
          <div class="head_box" v-if="list.OrderType!=1&&!isSeller&&(list.TaxPriceUsd&&list.TaxPriceUsd>0)">{{$t('base.stateTax')}} <span style="font-size:12px;">{{list|setTax}}</span></div>
          <div class="head_box">{{$t('base.orderTotal')}}</div>
        </div>
      </div>
      <div class="table_detail" :class="list.OrderType!=1&&!isSeller?'order_type':''">
        <!-- :class="list.OrderType!=1?" -->
        <div class="table_list_detail" :class="list.OrderType!=1&&!isSeller?'noOne':'oneOnly'">
          <div v-for="(res,i) in list.Details" :key="i">
            <div class="like_box">
              <el-image class="like_img" :src="res.TitImg" fit="contain"></el-image>
              <div class="like_detail">
                <p>{{res.Title}}</p>
              </div>
            </div>
            <div class="head_box">
              <div>{{res.QuantitySold}}</div>
              <!-- <div class="text_blue">3 bids</div> -->
            </div>
            <div class="head_box">
              <div>{{areaSymbol}} {{res.RealLowestPrice}}</div>
              <!-- <div class="text_blue">3 bids</div> -->
            </div>
          </div>
        </div>
        <div class="flex_layout_end flex_one">
          <div class="head_box RealPostageMoney">
            <div>{{areaSymbol}} {{list.RealPostageMoney}}</div>
          </div>
          <div class="head_box ServiceFee" v-if="list.OrderType!=1&&!isSeller">
            <div>{{areaSymbol}} {{(list.ServiceFee).toFixed(2)||0}}</div>
          </div>
          <div class="head_box TaxPrice" v-if="list.OrderType!=1&&!isSeller&&(list.TaxPriceUsd&&list.TaxPriceUsd>0)">
            <div>{{areaSymbol}} {{(list.TaxPriceUsd).toFixed(2)||0}}</div>
          </div>
          <div class="head_box setTotalPrice business_type_total_price">
            <del v-if="list.DiscountsPrice>0&&list.OrderType==1">$ {{setTotalPrice(1)}}</del>
            <div>{{areaSymbol}} {{isSeller?list.RealTotalPrice:setTotalPrice()}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 跨境详情 -->
    <div class="table_detail_box" v-if="list.BusinessType==2&&!list.IsCustomAdress">
      <div class="table_head BusinessType">
        <div class="commod head_box">{{$t('base.commodity')}}</div>
        <div class="head_box">{{$t('base.quantity')}}</div>
        <div class="head_box">{{$t('base.itemPrice')}}</div>
        <div class="head_box">{{$t('base.operate')}}</div>
      </div>
      <div class="table_detail" :class="list.OrderType!=1&&!isSeller?'order_type':''">
        <!-- :class="list.OrderType!=1?" -->
        <div class="table_list_detail BusinessType" :class="list.OrderType!=1&&!isSeller?'noOne':'oneOnly'">
          <div v-for="(res,i) in list.Details" :key="i">
            <div class="like_box">
              <el-image class="like_img" :src="res.TitImg" fit="contain"></el-image>
              <div class="like_detail">
                <p>{{res.Title}}</p>
              </div>
            </div>
            <div class="head_box">
              <div>{{res.QuantitySold}}</div>
              <!-- <div class="text_blue">3 bids</div> -->
            </div>
            <div class="head_box">
              <div>{{areaSymbol}} {{res.RealLowestPrice}}</div>
              <!-- <div class="text_blue">3 bids</div> -->
            </div>
          </div>
        </div>
        <div class="head_box setTotalPrice">
          <div class="hover" @click="allContact(list.SellerWyAccId,list.ID)">{{$t('base.contactSeller')}}</div>
        </div>
      </div>
    </div>
    <!-- 跨境详情 -->
    <div class="BusinessTypeTaxPrice" v-if="list.BusinessType==2&&!list.IsCustomAdress">
      <ul>
        <li><span>{{$t('colon.subtotal')}}</span><span>{{areaSymbol}} {{list.RealLowestPrice.toFixed(2)}}</span></li>
        <li><span>{{$t('colon.shipping')}}</span><span>{{areaSymbol}} {{list.RealPostageMoney.toFixed(2)}}</span></li>
        <li><span>{{$t('colon.buyerPremium')}}</span><span>{{areaSymbol}} {{(list.ServiceFee).toFixed(2)||0}}</span></li>
        <li class="total"><span>{{$t('colon.orderTotal')}}</span><span>{{areaSymbol}} {{setTotalPrice()}}</span></li>
      </ul>
    </div>
    <div class="BusinessTypeTaxPrice" v-if="list.BusinessType==2&&userInfo.MemberSource!='MO'&&!list.IsCustomAdress">
      <div class="icon_text">
        <i class="el-icon-warning-outline"></i><p>{{$t('alert.estWillBeOversea')}}</p>
      </div>
      <ul>
        <li><span>{{$t('colon.estimatedStateTax')}}</span><span>{{areaSymbol}} {{TaxServiceFee||0}}</span></li>
      </ul>
    </div>
    <!-- <ul>
      <li><span>邮费</span><span>$ {{list.RealPostageMoney.toFixed(2)}}</span></li>
      <li><span>服务费</span><span>$ {{(list.ServiceFee).toFixed(2)||0}}</span></li>
      <li><span>税</span><span>$ {{(list.TaxPrice).toFixed(2)||0}}</span></li>
      <li><span>总价</span><span>$ {{setTotalPrice()}}</span></li>
    </ul> -->
  </div></div>
</template>
<script>
import bus from '@/api/bus';
import { getInfo, getTime, countDown, setUTC,numAdd,numMulti,isNumber,doveCountDown,numDiv,priceExchange} from "@/api/public";
export default {
  name: 'tabslist',
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      cardHobbyAddress:'',
      isSeller:false,
      countDownType: '',//倒计时类型
      countDown: 0,//倒计时秒数
      doveTitle:'',
      doveDescription:'',
      loading: false,
      list: null,
      orderId: '',
      expList: '',
      nowData: new Date().getTime(),
      timer: "",
      exploading: false,
      userInfo: null,
      OrderStatus: this.$enumInfo.OrderStatus,
      TaxServiceFee:0,
      TaxDiscount:0
    }
  },
  filters: {
    setTimeSS(val) {
      if (!val) {
        return null
      }
      return getTime(val, -8, 0, 'cn')
    },
    setTax(val){
      var tax=0
      if(!val){
        return 0
      }
      tax=numDiv(val.TaxPrice,val.RealLowestPrice)*100
      tax=parseInt(tax)
      if(tax){
        tax="("+tax+"%)"
      }else{
        tax=""
      }
      return tax
    }
  },
  created() {
    // this.list = window.sessionStorage.getItem('history');
    // this.list = JSON.parse(this.list);orderId
    this.userInfo = getInfo()
    this.orderId = this.$route.params.id
    this.OrdersDetail()
    bus.$emit('headerTitle', this.$t('base.myCardHobby'));
    
  },
  mounted() { },
  methods: {
    // 获取税 
    /**
     * 获取税费价格信息
     * @param {Object} obj - 订单对象
     * @description 根据用户所在州和订单ID获取税费价格和折扣信息
     * 通过接口请求获取税费服务费和税费折扣金额,并转换为USD货币格式
     */
    GetTaxPrice(obj) {
      let that = this
      var StateName = that.userInfo.State
      let data = { operator_id: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, OrderId: obj.ID, StateName: StateName }
      let url = that.$interface.GetTaxPrice;
      that.$get(url, data).then(res => {
        if (res.result != 0) {
          that.TaxServiceFee = priceExchange(res.data.TaxPrice, 'USD')
          that.TaxDiscount = priceExchange(res.data.Discount, 'USD')
        }
      })

    },
    // 云信
    allContact(val,oid) {
      if (this.userInfo) {
        GoYunXin(this.userInfo, val,oid,1001)
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    },
    //type 1：官方商城折扣前总价
    setTotalPrice(type) {
      var TotalPrice = this.list.RealTotalPrice
      var ServiceFee = (this.list.ServiceFee).toFixed(2) || 0
      var TaxPrice = (this.list.TaxPriceUsd).toFixed(2) || 0
      var DiscountsPrice = (this.list.DiscountsPrice).toFixed(2) || 0
      TotalPrice = numAdd(isNumber(TotalPrice),numAdd(isNumber(ServiceFee),isNumber(TaxPrice)))
      if(type==1){
        TotalPrice=numAdd(isNumber(TotalPrice),isNumber(DiscountsPrice))
      }
      return TotalPrice.toFixed(2)
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
        if(this.countDown!=0){
          this.countDown=this.countDown - 1;
        }
      }, 1000);
    },
    DoveCountDown(itemEnd){
      var time=""
      if(itemEnd){
        time=doveCountDown(itemEnd)
      }
      if(time=='00:00'){
        this.OrdersDetail()
      }else{
        return time
      }
    },
    CountDown(itemEnd) {
      var time = '';
      if (itemEnd) {
        itemEnd = itemEnd.toString().replace(/-/g, "/")
        let val = setUTC(itemEnd, -8, 'cn')
        let newval = setUTC(this.nowData, -8)
        time = countDown(val, newval);
      }
      return time;
    },
    // 一口价跳转checkout
    /**
     * 处理立即购买操作
     * @param {Object} val - 订单信息对象
     * @description 根据订单类型(OrderType)处理不同的购买流程:
     * - 非官方商城订单(OrderType!=1): 重组订单详情并跳转到普通支付页
     * - 官方商城订单(OrderType=1): 重组商品ID和数量并跳转到购物车支付页
     * 处理后的数据会存储在sessionStorage中的'check'键下
     */
    BuyItNow(val) {
      let details = [];
      // 判断是否是官方商城订单 orderType=1是官方商城订单
      if (val.OrderType != 1) {
        //重组放入session Storage的内容
        val.Details.map(res => {
          details.push({
            "ID": res.ID,
            "Title": res.Title,
            "TitImg": res.TitImg,
            "USD_Price": res.RealLowestPrice,
          })
        })
        let data = {
          "RealLowestPrice": val.RealLowestPrice,
          "BusinessType": val.BusinessType,
          "HeadPortrait": val.StoreLogo,
          "SellRealName": val.SellerName,
          "BuyerWyAccId": this.userInfo.MappingUserId,
          "SellerWyAccId": '',
          "Details": details,
          "USD_PostageMoney": val.RealPostageMoney,
          "USD_TotalPrice": val.RealTotalPrice
        }
        window.sessionStorage.setItem('check', JSON.stringify(data))
        this.$router.push({
          path: '/pay/checkout/' + val.ID
        })
      } else {
        //重组放入session Storage的内容
        let commodityIds = [];
        let cuantitySold = [];
        let couponMemberID = [];
        val.Details.map(item => {
          commodityIds.push(item.ID);
          cuantitySold.push(item.QuantitySold);
        })
        let data = { commodityIds: commodityIds, cuantitySold: cuantitySold, Details: val.Details }
        window.sessionStorage.setItem('check', JSON.stringify(data))
        this.$router.push({
          path: '/pay/cartcheckout/' + val.ID
        })
      }
    },
    // 获取订单详情
    /**
     * 获取订单详情信息
     * 通过接口请求获取订单的详细信息,包括:
     * - 价格单位
     * - 代理商信息
     * - 卖家身份验证
     * - 倒计时状态处理
     * - 地址信息格式化
     * - 物流信息(非待付款状态)
     * - 税费信息(跨境业务)
     * @private
     * @returns {void}
     */
    OrdersDetail() {
      let that = this;
      that.loading = true;
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, orderId: that.orderId }
      this.$get(this.$interface.OrdersDetail, data).then(res => {
        if (res.result != 0) {
          let result = res.data
          that.areaSymbol=result.RealLowestPriceUnit
          that.GetAgency(result)
          that.isSeller= result.SellerWyAccId==that.userInfo.MappingUserId?true:false
          let CountDownType=res.data.CountDownType//倒计时类型
          let CountDown=res.data.CountDown//倒计时秒数
          that.countDownType=CountDownType
          that.countDown=CountDown
          if(CountDownType!=0){
            //鸽子
            that.doveTitle=""
            that.doveDescription=""
            if(CountDownType==1){
              that.doveTitle=that.$t('alert.non-paymentResult1')
            }
            if(CountDownType==2){
              that.doveTitle=that.$t('alert.non-paymentResult2')
            }
            if(CountDownType>=3){
              that.doveTitle=that.$t('symbol.anyClose')
              that.doveDescription=that.$t('alert.non-paymentResult2')
            }
            this.cardTimer()
          }
            //this.cardTimer()
          // start
          let add = res.data.Address
          let add1=res.data.Address
          if(add1){
          if(add1.indexOf('()')>0){
            // var a=add1.indexOf('()')
            // console.log(add1,a,'add2',add1.substring(0,a))
            //var reg=new RegExp()
            add1 = add1.replace(/\(\)/g, "")
          res.data.Address=add1
          }else{
          add1 = add1.replace(")", "")
          add1 = add1.replace("(", "|")
          add1 = add1.split("|")
          res.data.Address=add1[1]&&add1[1]!='' ? add1[0]+' '+add1[1] : add1[0]
          }
        }else{
          res.data.Address=add
        }
          that.list = res.data;
          // 获取物流信息
          if (result.OrderStatus != 1) {
            this.GetExpress(result)
          }
          // 获取税费
          if(result.BusinessType==2){
            this.GetTaxPrice(result)
          }
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }

        that.loading = false;
      })
    },
    // 获取物流信息
    /**
     * 获取物流快递信息
     * @param {Object} obj - 包含快递信息的对象
     * @param {string} obj.Express - 物流单号
     * @param {string} obj.ExpressCode - 快递公司代码
     * @param {string} obj.Mobile - 手机号码
     * @param {string} obj.ID - 订单编号
     * @description 根据快递单号和快递公司代码查询物流轨迹信息，结果存储在 expList 中
     */
    GetExpress(obj) {
      let that = this;
      that.exploading = true
      that.expList = '';
      let data = { LogisticCode: obj.Express, ShipperCode: obj.ExpressCode, Mobile: obj.Mobile, OrderCode: obj.ID }
      //let data = { LogisticCode: 'SF0281281553683', ShipperCode: 'SF', Mobile: obj.Mobile, OrderCode: obj.ID }
      this.$get(this.$interface.GetExpressInfoByShipperCode, data).then(res => {
        if (res.result != 0) {
          if (res.Data == null) {
            that.expList = { Traces: [] }
          } else {
            that.expList = res.Data
          }
        } else {
          that.expList = { Traces: [] }
        }
        that.exploading = false
        //console.log(res)
      })
    },
    //获取办事处地址信息
    /**
     * 获取代理商信息并格式化地址
     * @param {Object} obj - 包含会员来源信息的对象
     * @description 根据用户ID和令牌获取代理商信息，处理省份代码，
     * 并将代理商地址、省份和国家信息组合成完整地址字符串存储在 cardHobbyAddress 中
     */
    GetAgency(obj) {
      let that = this
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, memberSource: (obj.MemberSource||obj.SellMemberSource) }
      this.$get(this.$interface.GetAgency, data).then(res => {
        if (res.result != 0) {
          var Provice = res.data.Provice
          var StateCode = ''
          res.data.StateCode = res.data.Provice
          if (Provice.indexOf(')') != -1) {
            Provice = Provice.replace(")", "")
            Provice = Provice.replace("(", "|")
            Provice = Provice.split("|")
            StateCode = Provice[1]
            Provice = Provice[0]
            res.data.Provice = Provice
            res.data.StateCode = StateCode
          }
          that.cardHobbyAddress = res.data.AgencyAddress + ", " + res.data.Provice + ", " + res.data.Nation + "."
        }
        //console.log(res, Provice, 'res')
      })
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/orderdetail.css";

.table_head .commod {
  width: 495px;
  padding-left: 108px;
}
.table_head.BusinessType .commod{
  width:718px;
}

.table_head .Premium {
  width: 200px;
}

.table_list_detail .like_box {
  width: 388px;
}

.table_list_detail .like_detail {
  width: 288px;
}

.table_list_detail.noOne {
  width: 645px;
}
.table_list_detail.noOne.BusinessType{
      width: calc(100% - 118px);
}
.order_type .head_box.RealPostageMoney {
  width: 130px;
}
.head_box.ServiceFee {
  width: 158px;
}
.head_box.TaxPrice {
  width: 128px;
}
.order_type .head_box.setTotalPrice {
  width: 118px;
  padding-right: 0;
}
.ordertype .table_list_detail > div:first-child {
  min-width: 645px;
  width: auto;
}
.ordertype .head_box.RealPostageMoney{
  width: 158px;
}
.ordertype .head_box.setTotalPrice{
  width: 150px;
}
.table_list_detail .like_box{width: 488px;}
.table_list_detail.BusinessType .like_box{width: 710px;}
.table_list_detail.BusinessType .like_detail{
      width: calc(100% - 100px);}
.RemainingAlert{
  margin-top:12px;
}
.hover{
  cursor: pointer;
}
.hover:hover{
  color: #5F6DAE;
  text-decoration: underline;
}
.BusinessTypeTaxPrice{
  display: flex;
  justify-content: flex-end;
}
.BusinessTypeTaxPrice+.BusinessTypeTaxPrice{
  justify-content: space-between;
  border-top:1px solid #d9d9d9;
      margin-top: 10px;
    padding-top: 10px;
}
.BusinessTypeTaxPrice .icon_text{
  display: flex;
  width: 50%;
  color: #a0a0a0;
}
.BusinessTypeTaxPrice .icon_text p{
  margin-left: 3px;
}
.BusinessTypeTaxPrice ul{
  width: 275px;
}
.BusinessTypeTaxPrice ul li{
  display: flex;
  line-height:2;
}
.BusinessTypeTaxPrice ul li span{
  width: 200px;
  text-align: left;
  color: #a0a0a0;
}
.BusinessTypeTaxPrice ul li span+span{
  text-align: right;
  color: #333;
}
.BusinessTypeTaxPrice ul li.total span{
  color: #5F6DAE;
}
.BusinessTypeTaxPrice ul li.total span+span{
  font-size: 18px;
  font-weight: 700;
}


.BusinessType_head .head_box{
  width: 127px;
}

.BusinessType_head .Premium {
  width: 157px;
}
.BusinessType_head .commod{
  width: 404px;
}

.order_type .head_box.business_type_total_price{
  padding-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/detail.vue